import React, { useEffect, useLayoutEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Layouts from '../../components/layouts';
import Cookies from 'js-cookie';

import {
	useAllQuestions,
	useLocalStorageHook,
	useOtherAuth,
	useQuestionnaires,
} from '../../Common';

const User = () => {
	useOtherAuth();
	useAllQuestions();
	useQuestionnaires();
	const location = useLocation();
	const navigate = useNavigate();
	const [, , clearValue] = useLocalStorageHook('questions', null);
	useEffect(() => {
		location.pathname !== '/home/template-builder' && clearValue();
	}, [clearValue, location.pathname]);
	useLayoutEffect(() => {
		if (!Cookies.get('refresh')) return navigate('../signin');
	}, [navigate]);

	return (
		<Layouts type='user'>
			<Outlet />
		</Layouts>
	);
};

export default User;
